module.exports = __webpack_public_path__ + "static/media/TCIntraFull.08d69173.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/TCIntraFull.png
// module id = 370
// module chunks = 0